import { getCuota } from "../services/servicesTablasDesarrollo";

export interface CalculoCuotaRequest {
    TablaDesarrolloId: number;
    MontoCredito: number;
}

export interface CalculoCuotaResponse {
    valorCuota: number;
    valorUltimaCuota: number;
}

export function useTablasDesarrollo() {

    const calcularCuotasDesdeTablaDesarrollo = async (calculoCuotaRequest: CalculoCuotaRequest) => {

        const resp = await getCuota(calculoCuotaRequest)

        if (resp && resp.status === 200) {
            const data: CalculoCuotaResponse = await resp.data;
            return data;
        }

    }

    return { calcularCuotasDesdeTablaDesarrollo };
}
